import {
  useCategory,
  useCategories,
  useUpdateCategory,
} from "../../../hooks/useCategories";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";

// Redux

import { Link, useHistory, useParams } from "react-router-dom";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond
import { registerPlugin } from "react-filepond";

// Import FilePond styles
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import { toast } from "react-toastify";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const EcommerceUpdateCategories = (props) => {
  document.title = props.t("Modifier Categories");
  const history = useHistory();

  const categoriesId = useParams();
  const [selectCategory, setSelectCategory] = useState({});
  const { data: selected = {} } = useCategory(categoriesId.id);
  const { data: categoryFetch = [] } = useCategories();
  const updateCategoryMutation = useUpdateCategory();

  useEffect(() => {
    if (selected) setSelectCategory(selected);
  }, [selected]);

  const [category, setCategoryList] = useState([]);
  useEffect(() => {
    setCategoryList(categoryFetch);
  }, [categoryFetch]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      designation: selectCategory.designation || "",
    },

    validationSchema: Yup.object().shape({
      designation: Yup.string().required(props.t("Entrer un nom")),
    }),

    onSubmit: (values) => {
      const newCategory = {
        id: selectCategory.id,
        designation: values.designation,
      };

      var count = 0;
      if (newCategory) {
        for (let i = 0; i <= category.length; i++) {
          if (newCategory.designation === category[i]?.designation) {
            count = count + 1;
            history.push("/categories");
            toast.error(props.t("La categorie existe deja"), {
              autoClose: 3000,
            });
            break;
          }
        }
        if (count === 0) {
          updateCategoryMutation.mutate(
            { id: categoriesId.id, payload: newCategory },
            {
              onSuccess: () => {
                toast.success(props.t("Catégorie bien modifiée"), {
                  autoClose: 3000,
                });
              },
              onError: () => {
                toast.error(props.t("Catégorie non modifiée"), {
                  autoClose: 3000,
                });
              },
            }
          );
          history.push("/categories");
          validation.resetForm();
          setTimeout(() => window.location.reload(true), 2000);
        } else {
          count = 0;
        }
      }
    },
  });
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Modification de catégorie")}
          pageTitle={props.t("Catégorie")}
        />

        <Row>
          <Col lg={12}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="designationCat">
                      {props.t("Titre de la catégorie")}
                    </Label>
                    <Input
                      type="text"
                      className="form"
                      name="designation"
                      value={validation.values.designation}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    />
                    {validation.errors.designation &&
                    validation.touched.designation ? (
                      <FormFeedback type="invalid">
                        {validation.errors.designation}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>

              <div className="text-end mb-3">
                <Link to="/categories" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-warning w-sm m-2"
                  disabled={updateCategoryMutation.isPending}
                >
                  {updateCategoryMutation.isPending && (
                    <Spinner size="sm" className="me-2" />
                  )}
                  {props.t("Modifier")}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

EcommerceUpdateCategories.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(EcommerceUpdateCategories));
